import { render, staticRenderFns } from "./diagram-two.vue?vue&type=template&id=644629f2&scoped=true&"
import script from "./diagram-two.vue?vue&type=script&lang=js&"
export * from "./diagram-two.vue?vue&type=script&lang=js&"
import style0 from "./diagram-two.vue?vue&type=style&index=0&id=644629f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644629f2",
  null
  
)

export default component.exports